import React, { useState, useRef, useEffect } from 'react';
import { useThemeStore } from '../../store/theme.store';
import './ProfessionalModeIcon.css';

export function ProfessionalModeIcon() {
    const { isProfessionalMode, isCustomCursorActive, toggleCustomCursor } = useThemeStore();
    const [isHovered, setIsHovered] = useState(false);
    const audioRef = useRef<HTMLAudioElement | null>(null);

    useEffect(() => {
        if (!isProfessionalMode) return;

        // Try multiple potential audio file names
        const audioPaths = ['/kursor_muzyka_1.mp3', '/welcome.mp3'];
        let currentIndex = 0;

        const loadAudio = (path: string) => {
            const audio = new Audio(path);
            audio.loop = true;
            audioRef.current = audio;

            audio.onerror = () => {
                currentIndex++;
                if (currentIndex < audioPaths.length) {
                    loadAudio(audioPaths[currentIndex]);
                }
            };
        };

        loadAudio(audioPaths[0]);

        return () => {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current = null;
            }
        };
    }, [isProfessionalMode]);

    useEffect(() => {
        if (isHovered && isProfessionalMode && audioRef.current) {
            audioRef.current.play().catch(err => console.log('Audio playback failed:', err));
        } else if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
    }, [isHovered, isProfessionalMode]);

    if (!isProfessionalMode) return null;

    return (
        <div
            className={`professional-mode-icon-container ${isHovered ? 'hovered' : ''} ${isCustomCursorActive ? 'active' : ''}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={toggleCustomCursor}
            title={isCustomCursorActive ? "Wyłącz customowy kursor" : "Włącz customowy kursor"}
        >
            <img
                src="/kursor_ikona_1.svg"
                alt="Pro Mode"
                className={`professional-mode-icon ${isHovered ? 'rotating' : ''}`}
            />
        </div>
    );
}
